if ($('.before-and-after__carousel').length > 0) {
  // debounce from underscore.js
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  // use x and y mousewheel event data to navigate flickity
  function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
    // do not trigger a slide change if another is being animated
    if (!slick_is_animating) {
      // pick the larger of the two delta magnitudes (x or y) to determine nav direction
      var direction =
        Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

      console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

      if (direction > 0) {
        // next slide
        slick_instance.slick("slickNext");
      } else {
        // prev slide
        slick_instance.slick("slickPrev");
      }
    }
  }

  // debounce the wheel event handling since trackpads can have a lot of inertia
  var slick_handle_wheel_event_debounced = debounce(
    slick_handle_wheel_event
    , 100, true
  );


  let initialSlide = 0;
  const $beforeAfterSlider = $('.before-and-after__carousel');

  $beforeAfterSlider.each(function(index, el) {
    const isActive = $(this).hasClass("active");
    if(isActive) {
      initialSlide = index;
    }
  })

  const $progressBar = $('.before-and-after .progress');
  const $progressBarLabel = $( '.before-and-after .slider__label' );

  $beforeAfterSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    let calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

    console.log('slide number', currentSlide);

    if ($(window).width() >= 768){
      if (calc >= 60){
        calc = 100;
      }
    }

    if (calc === 0) {
      calc = 15;
    }

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

    $progressBarLabel.text( calc + '% completed' );
  });


  $('.before-and-after__carousel').slick({
    infinite: false,
    dots: false,
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          infinite: false,
          dots: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          dots: false,
          centerMode: true,
          centerPadding: '22px',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      }
    ]
  });

  var slick_1_is_animating = false;

  $('.before-and-after__carousel').on("afterChange", function(index) {
    slick_1_is_animating = false;
  });

  $('.before-and-after__carousel').on("beforeChange", function(index) {
    slick_1_is_animating = true;
  });

  $('.before-and-after__carousel').on("wheel", function(e) {
    slick_handle_wheel_event_debounced(e.originalEvent, $('.before-and-after__carousel'), slick_1_is_animating);
  });


}